module.exports = __webpack_public_path__ + "media/ping.f5137dc0.mp3";